import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useToast } from '@/src/general/components/ToastContext'
import { useTranslate } from '@/src/lang/useTranslate'

import { fraternityApi } from '../api/fraternityApi'
import type { TFraternityOnboarding, TFraternityOnboardingPatch } from '../api/fraternityApi.types'
import { fraternityOnboardingQueryOptions } from './useFraternityOnboardingQuery'

export const useFraternityOnboardingMutation = () => {
  const queryClient = useQueryClient()
  const { addToast } = useToast()
  const { t } = useTranslate()

  return useMutation({
    mutationFn: async (payload: TFraternityOnboardingPatch) => {
      try {
        const data = await fraternityApi.patchFraternityOnboarding(payload)
        queryClient.setQueryData(fraternityOnboardingQueryOptions().queryKey, data)
        return data
      } catch {
        addToast({
          colors: 'danger',
          message: t('common.error.unknown'),
        })
        // Resolve so callers can advance; do not write the query cache.
        return queryClient.getQueryData<TFraternityOnboarding>(fraternityOnboardingQueryOptions().queryKey)
      }
    },
  })
}
